import React, { useEffect } from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import { Trans, useTranslation } from "react-i18next";

const cardStyle = { fontWeight: 300, display: "inline-block" };
export const Page = ({
  title,
  children,
  filterType,
  filterValue,
  filterTypeName,
  card = true,
  cardBodyClassName,
  translate = true,
  printTitle = true,
  showTitle=true,
  titleClass,
  ...props
}) =>
{
  const {t} = useTranslation()
  useEffect(()=>{
    document.title =  `${title? title+" | " : ""}` + `${t("Hesaab | Your Xero Report Translation Partner")}`;
  },[])
  return card ? (
    <Card className="" {...props}>
      <CardBody className={cardBodyClassName}>
        {showTitle && title && (
          <CardTitle
            className={"my-2"+ !printTitle ? "d-print-none" : ""}
          >
            {translate ? <span className={titleClass} style={{textTransform:"capitalize"}}><Trans>{title}</Trans></span> : title}
          </CardTitle>
        )}
        <div className="mt-1">{children}</div>
      </CardBody>
    </Card>
  ) : (
    <div className="mt-2" {...props}>
      <div>
        <CardTitle
          style={cardStyle}
          className={!printTitle ? "d-print-none" : ""}
        >
          {translate ? <Trans>{title}</Trans> : title}
        </CardTitle>
        <div className="mt-1">{children}</div>
      </div>
    </div>
  );
}

export default Page;
